export const AdvertisingResearchIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <g opacity='1'>
        <path
          d='M9.33464 7.33203H5.33464M6.66797 9.9987H5.33464M10.668 4.66536H5.33464M13.3346 6.9987V4.53203C13.3346 3.41192 13.3346 2.85187 13.1166 2.42405C12.9249 2.04772 12.619 1.74176 12.2426 1.55002C11.8148 1.33203 11.2548 1.33203 10.1346 1.33203H5.86797C4.74786 1.33203 4.18781 1.33203 3.75999 1.55002C3.38366 1.74176 3.0777 2.04772 2.88596 2.42405C2.66797 2.85187 2.66797 3.41192 2.66797 4.53203V11.4654C2.66797 12.5855 2.66797 13.1455 2.88596 13.5734C3.0777 13.9497 3.38366 14.2556 3.75999 14.4474C4.18781 14.6654 4.74786 14.6654 5.86797 14.6654H7.66797M14.668 14.6654L13.668 13.6654M14.3346 11.9987C14.3346 13.2874 13.29 14.332 12.0013 14.332C10.7126 14.332 9.66797 13.2874 9.66797 11.9987C9.66797 10.71 10.7126 9.66536 12.0013 9.66536C13.29 9.66536 14.3346 10.71 14.3346 11.9987Z'
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </svg>
  )
}
